module.exports = __webpack_public_path__ + "img/sierras3.4f92e57.jpg";